import { PathId } from "features/Path/models";
import { TertiaryButton } from "components/Button";
import { TemplatePrefixId } from "features/Resources/SharedTemplate/models";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { useAddTemplateToPath } from "features/Path/hooks";

interface AddTemplateToPathRowButtonProps {
  pathId: PathId;
  templatePrefixId: TemplatePrefixId;
}

export default function AddTemplateToPathRowButton({ pathId, templatePrefixId, ...props }: AddTemplateToPathRowButtonProps) {
  const { mutate: addTemplateToPath } = useAddTemplateToPath({ pathId, templatePrefixId });

  return (
    <ButtonWithConfirm
      header="Add Template To Path"
      body="Please confirm you want to add this template to the path"
      handleConfirm={addTemplateToPath}
      confirmButtonText="Add to Path"
      intent="confirmation"
    >
      <TertiaryButton h="30px" {...props}>Add to Path</TertiaryButton>
    </ButtonWithConfirm>
  );
}
